/* global Modal, Inretrn*/
if (!customElements.get('m-inretrn-pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class MInretrnPopUp extends Modal {
      constructor() {
        super();
        this.orderNumber = null;
        this.customerEmail = null;
        this.languageCode = null;
        this.sellerId = +this.dataset.sellerId || 1;

        if (this.dataset.showOnMobile === 'true') {
          if (this.dataset.trigger === 'click') {
            this.getDataForIframe();
          }
        }
      }

      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }

        if (this.copyHandler) {
          document.removeEventListener('copy', this.copyHandler);
        }
      }

      close() {
        super.close();
      }

      getDataForIframe() {
        const returnOrderBtns = document.querySelector('#main-content');
        if (!returnOrderBtns) return;

        returnOrderBtns.addEventListener('click', (event) => {
          if (event.target.classList?.contains('m-js-return-link')) {
            this.orderNumber = event.target.dataset.orderNumber;
            this.customerEmail = event.target.dataset.customerEmail || this.dataset.customerEmail;
            this.languageCode = event.target.dataset.languageCode || this.dataset.languageCode;
            this.handleOpenClick();
          }
        });
      }

      handleOpenClick() {
        this.renderPopupContent();
        this.open();
      }

      renderPopupContent() {
        const contentElement = this.querySelector('.m-js-pop-up-content');
        const orderNumberWrapper = this.querySelector('.m-js-order-number');
        if (contentElement) {
          contentElement.innerHTML = ` 
            <inretrn-returns class="tw-w-full tw-h-full tw-border-[rgba(var(--text-color)/.1)]"></inretrn-returns>
          `;
        }
        if (orderNumberWrapper) {
          orderNumberWrapper.innerHTML = this.orderNumber || '';
        }

        this.callIframe();
      }

      callIframe() {
        // this code is provided by the Inretrn app, do not touch.
        // Documentation about customization this section you can find here:
        // https://docs.inretrn.com/en/digital-returns
        const m = location.href.match(/#(.)+$/);

        let s = btoa(`${this.orderNumber || ''}:${this.customerEmail || ''}:hultaforsgroup`);
        if (m && m.length > 0) {
          s = m[0].substr(1);
        }

        Inretrn.init({
          drToken: s,
          languageCode: this.languageCode,
          sellerId: this.sellerId,
          ReturnType: 'return',
          useB2BGUI: false,
        });
      }
    }

    customElements.define('m-inretrn-pop-up', MInretrnPopUp);
  });
}
